import React, { useState } from "react";
import "./ModalEditField.css";
import { useUpdateProfile } from "../../../hooks/useUpdateProfile";

const ModalEditField = ({ field, value, onSave, onClose }) => {
  const [inputValue, setInputValue] = useState(value || "");
  const { updateProfileField } = useUpdateProfile();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await updateProfileField(field, inputValue);
    if (success) {
      onSave(inputValue);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Update {field}</h3>
        <form onSubmit={handleSubmit}>
          <label>{field}</label>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          <div className="modal-buttons">
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancel
            </button>
            <button type="submit" className="save-btn">
              Change
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalEditField;
